import useTasksFiltersFormik from "@timenotes/shared/src/services/tasks/hooks/use-tasks-filters-formik"
import { TaskFilter } from "./components/task-filter"
import { useProjectBoard } from "@timenotes/shared/src/features/project-board"

interface Props {
  projectId: string
}

const TasksFiltersContainer = (props: Props) => {
  const {
    projectId
  } = props

  const {
    tasksFiltersFormik,
  } = useProjectBoard()

  return (
    <TaskFilter 
      projectId={projectId}
      tasksFiltersFormik={tasksFiltersFormik}
      canSetTimeLogBillable={true}
    />
  )
}

export default TasksFiltersContainer